// desyr.chat — the entry point for every page (a module, so it runs once the markup is parsed).
// Every page has the nav; each page names itself with data-page on <body>, and only its own
// components run.
import { initBento } from "./components/bento.js";
import { initCipher } from "./components/cipher.js";
import { initContact } from "./components/contact.js";
import { initFaq } from "./components/faq.js";
import { initHeroChat } from "./components/hero-chat.js";
import { initInstall } from "./components/install.js";
import { initLanguageSwitch } from "./components/language-switch.js";
import { initPointerEffects } from "./components/pointer-effects.js";
import { initReveal } from "./components/reveal.js";
import { initScrollProgress } from "./components/scroll-progress.js";
import { initSectionNav } from "./components/section-nav.js";
import { initSiteMenu } from "./components/site-menu.js";
import { initThemeSwitch } from "./components/theme-switch.js";
import { initWordmark } from "./components/wordmark.js";
import { initWords } from "./components/words.js";

const pages: Record<string, (() => void)[]> = {
  index: [
    initHeroChat,
    initSectionNav,
    initWords,
    initScrollProgress,
    initBento,
    initCipher,
    initReveal,
    initFaq,
    initContact,
  ],
  install: [initInstall],
};

for (const init of [
  initThemeSwitch,
  initLanguageSwitch,
  initSiteMenu,
  initPointerEffects,
  initWordmark,
  ...(pages[document.body.dataset.page ?? ""] ?? []),
]) {
  init();
}
